import React from "react";

const HamburgerIcon = ({ isOpen = false }) => {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.625 6.625H18.625M0.625 0.625H18.625M0.625 12.625H18.625" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>



  );
};

export default HamburgerIcon;
